module.exports = __webpack_public_path__ + "media/images/symbols/logo-b146cc3a9aa086b3ca5fad936523c3e0.svg";